import React from 'react';
import OtpInput from "react-otp-input";

export function OtpField(props) {
   
  let {otp, setOtp ,errors, name } = props;
  
  let error = undefined;

  if(errors !== undefined && errors !== null){
    if(errors?.mobile !== undefined){
      error = undefined;
    }else{
      error = { otp : "Invalid OTP entered. Please enter again"}
  }
  }


  const handleChange = (otp) => setOtp(otp)

  
  const inputStyle = {
    border: "2px solid #c8e8e8",
    borderRadius: "8px",
    width: "54px",
    height: "54px",
    fontSize: "12px",
    color: "#000",
    caretColor: "black"
  }

  return (
    <>
    <div className="text-center m-auto otp" >
      <OtpInput
        value={otp}
        onChange={handleChange}
        numInputs={4}
        isInputNum={true}
        shouldAutoFocus={true}
        inputStyle={inputStyle}
      />
       {error?.[name] && <p className="text-scogoRed text-font10 font-normal pt-2 mt-4">{error?.[name]}</p>}
    </div>
    </>
  );
}
